import _ from 'lodash'
import { useStore } from '@tanstack/react-store'

import { Json, LegacyPage, Button, LoadingContainer } from 'peach/components'
import { formatMilliseconds } from 'peach/helpers'
import { useNow } from 'peach/hooks'

import { authStore, authActions } from 'core/auth/authStore'

import {
  useUserPermissions_get,
  useInternalBorrowerGet,
  useInternalUserGet,
  useInternalEmployeeGetById,
} from 'core/types'

const Settings = () => {
  const currentAuthState = useStore(authStore)

  const { companyId, personId, userId, decodedToken, expiresAt } =
    currentAuthState
  const employeeId = decodedToken?.employeeId

  const { data: permissionsHash, isLoading: isLoadingPermissions } =
    useUserPermissions_get({})

  const { data: person, isLoading: isLoadingPerson } = useInternalBorrowerGet({
    companyId,
    personId,
    options: {
      enabled: !!personId,
    },
  })

  const { data: user, isLoading: isLoadingUser } = useInternalUserGet({
    companyId,
    userId,
    options: {
      enabled: !!companyId && !!userId,
    },
  })

  const { data: employee, isLoading: isLoadingEmployee } =
    useInternalEmployeeGetById({
      companyId,
      employeeId,
      options: {
        enabled: !!companyId && !!employeeId,
      },
    })

  const displayPermissions = _.map(permissionsHash, (permissions, id) => {
    const split = _.map(permissions, (str) => {
      const [type, action] = str.split(':')
      return { type, action }
    })

    const byCategory = _.mapValues(_.groupBy(split, 'type'), (list) =>
      _.map(list, 'action').join(', '),
    )

    return { companyId: id, permissions: byCategory }
  })

  const now = useNow()

  const expiresIn = expiresAt ? formatMilliseconds(expiresAt - now) : 'N/A'

  return (
    <LoadingContainer
      loading={
        isLoadingPermissions ||
        isLoadingPerson ||
        isLoadingUser ||
        isLoadingEmployee
      }
    >
      <LegacyPage.Centered>
        <Json.Table
          json={{ ...currentAuthState, expiresIn }}
          title='Auth Store State'
        />
        <Button onClick={authActions.renewSession}>Renew Session</Button>
        <Json.Table json={user} title='Session User' />
        <Json.Table json={person} title='Session Person' />
        <Json.Table json={employee} title='Session Employee' />

        <Json.Table json={displayPermissions} title='Session Permissions' />
      </LegacyPage.Centered>
    </LoadingContainer>
  )
}

export default Settings
